var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar navbar-expand-lg"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"collapse navbar-collapse justify-content-end"},[_c('user-info'),_c('lang-btn')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }